export default function tinyload(url, callback) {

	var image = new Image();
	image.onload = callback;
	
	image.onerror = function() {
		console.log('error loading ' + url);
	};
    image.src = url;
    
    return image;
}